

































import VueOptions from '@utils/VueOptions'
import WizardNavbar from '@ui/AudienceCreativeWizard/WizardNavbar'
import WizardNavigation from '@ui/AudienceCreativeWizard/WizardNavigation'
import VenueLocationForm from '@ui/VenueWizard/Forms/VenueLocationForm'
import Modal from '@components/Modal'

settings =
  name: 'VenueEditStep'

  resources:
    venue:
      resourceName: 'venue'
      slug: 'suppliers/:wizard.supplierId/audience_creatives/:audienceCreativeId/venues/:venueId/edit'

  vue:
    props: ['wizard', 'step']

    components: {
      WizardNavbar,
      WizardNavigation,
      VenueLocationForm,
      Modal,
    }

    data: ->
      confirmModal:
        show: false
        stepName: false

    computed:
      venueId: ->
        @$route.query.venueId

      form: ->
        data: @prime.venue || {}
        errors: @formErrors.venue || {}

      actionsFormVenueForm: ->
        saveField: @saveField

      displayConfirmModal: ->
        Object.keys(@form.errors).length > 0

    methods:
      hiConfirmModal: (stepName) ->
        @confirmModal.show = true
        @confirmModal.stepName = stepName

      saveField: (fieldName) ->
        @saveItemField 'prime.venue', fieldName, { skipFlash: true }

      onSave: (item) ->
        @prime.venue[key] = value for key, value of item

export default VueOptions.vue settings
